/**
 * Extracts phone number from a given input string.
 *
 * This function removes all non-digit characters from the input string and handles
 * country codes by ignoring the leading '1' if present. It ensures that the returned
 * phone number is up to 10 digits long.
 *
 * @param {string} number - The input phone number string, which may contain non-digit characters and country codes.
 * @returns {string} - Up to 10-digit phone number string.
 *
 * @example
 * // Returns '8001234567'
 * getUnformated10DigitPhoneNumber('1-800-123-4567');
 *
 * @example
 * // Returns '1234567890'
 * getUnformated10DigitPhoneNumber('(123) 456-7890');
 */
export const sanitizePhoneNumberTo10Digits = (number: string) => {
  let digits = number.replace(/\D/g, '').slice(0, 11); // 11 to account for the extra country number (1) at the beginning

  // ignore the extra country number (1) at the beginning if any
  if (digits.length > 10 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }

  // limit the digits to 10
  return digits.slice(0, 10);
};
